import React, { useEffect, useState } from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import "./signupOverlay.scss";
import { Loading } from "../Other/Loading";
import CheckIcon from "../../assets/images/check-icon.png";
import SendEmailAgain from "./SendEmailAgain";
import axiosInstance from "../../axios";
import { useNavigate } from "react-router-dom";

const SignupOverlay = ({ setVerificationModal, email, verificationModal }) => {
  const [time, setTime] = useState(0);
  const [isloading, setIsLoading] = useState(false);
  const [manageResendMail, setManageResendMail] = useState(false);
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let interval = null;

    if (time > 0) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    }
    return () => {
      clearInterval(interval);
      setIsLoading(false);
    };
  }, [time]);

  const handleCloseVerification = () => {
    setVerificationModal(!verificationModal);
    navigate("/login");
  };

  const handleResendMail = async () => {
    setIsLoading(true);
    setLoader(true);

    try {
      const res = await axiosInstance.post("/get-verification-link", { email });

      if (!res?.data?.error) {
        setManageResendMail(true);
      }
    } catch (err) {
      console.error("Error resending verification mail:", err.message);
      // Optionally: show user-friendly feedback here
    } finally {
      setIsLoading(false);
      setLoader(false);
    }
  };

  return (
    <>
      {manageResendMail === false && (
        <OverlayContainer>
          <div className="signup-dialog-inner">
            <div className="signup-modal-heading">
              <div className="signup-title">
                <h1>Please Verify Email</h1>
              </div>
              <div
                className="signup-dialog-close"
                onClick={handleCloseVerification}
              >
                <div>
                  <i className="icon check"></i>
                </div>
              </div>
            </div>
            <div className="signup-message">
              <p>
                We have sent an email to <b>{email}</b>. You need to verify your
                email to continue.
              </p>
            </div>
            <div className="signup-message-2">
              <p>
                If you’ve not received the verification email, please check your
                “Spam” folder. You can also click the resend button below to
                have another email sent to you.
              </p>
            </div>

            <div className="signup-close-btn">
              <button onClick={handleCloseVerification}>Okay</button>
            </div>
            <div className="resend-email">
              <div
                className={
                  !time > 0 ? "resend-email-title" : "resend-email-disabled"
                }
                onClick={handleResendMail}
              >
                <p>
                  Didn’t receive the verification email? <span>Resend</span>
                </p>
              </div>
            </div>
          </div>
        </OverlayContainer>
      )}

      {loader === true && (
        <OverlayContainer>
          <div className="signup-loading">
            <Loading />
          </div>
        </OverlayContainer>
      )}
      {loader === false && manageResendMail === true && (
        <SendEmailAgain
          isloading={isloading}
          setIsLoading={setIsLoading}
          handleCloseVerification={handleCloseVerification}
          email={email}
          setResendVerification={setVerificationModal}
          time={time}
          setTime={setTime}
          handleResendMail={handleResendMail}
        />
      )}
    </>
  );
};

export default SignupOverlay;
